import { Input, Component } from "@angular/core";
import { environment } from "../../../environments/environment";

@Component({
  selector: "app-planning-poker-risk-indicator-header",
  templateUrl: "./planning-poker-risk-indicator-header.component.html",
  styleUrls: ["./planning-poker-risk-indicator-header.component.scss"],
})
export class PlanningPokerRiskIndicatorHeaderComponent {
  @Input() riskIndicator: any;
  env: any = environment;

  constructor() {}
}



// WEBPACK FOOTER //
// /agir/src/app/components/planning-poker-risk-indicator-header/planning-poker-risk-indicator-header.component.ts